var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"img",class:`${_vm.className} ${_vm.statusClass}`,attrs:{"src":_vm.src,"alt":_vm.alt,"title":_vm.title},on:{"error":_vm.setDefault}})
}
var staticRenderFns = []

export { render, staticRenderFns }